export const humanFileSize = (size: number) => {
    let i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
    return ((size / Math.pow(1024, i)) as any).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
}

export const setCookie = (cname: string, cvalue: string, exdays: number) => {
    const d = new Date();
    // d.setTime(d.getTime() + (exdays*24*60*60*1000));
    d.setTime(d.getTime() + (exdays * 1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

// export const getCookie = (cname: string) => {

// }